import { setSettingsPage } from "../../../actions/session";
import ErrorBoundary from "../../../controls/ErrorBoundary";
import { ComponentEx, connect } from "../../../controls/ComponentEx";
import { bytesToString, truthy } from "../../../util/util";
import { NUM_SPEED_DATA_POINTS } from "../reducers/state";
import * as React from "react";
import ResizeDetector from "react-resize-detector";
import * as recharts from "recharts";
/**
 * download speed dashlet
 */
class DownloadGraph extends ComponentEx {
    constructor(props) {
        super(props);
        this.initState({ width: 800 });
    }
    componentDidMount() {
        this.forceUpdate();
    }
    render() {
        const { t, maxBandwidth, speeds } = this.props;
        const data = this.convertData(speeds);
        let showLimit = false;
        let maxData = Math.max(...speeds);
        if (maxBandwidth !== 0 &&
            maxBandwidth !== null &&
            maxData * 1.5 > maxBandwidth) {
            maxData = maxBandwidth * 1.2;
            showLimit = true;
        }
        const maxRounded = this.byteRound(maxData);
        const ticks = [
            0,
            this.byteRound(maxRounded / 3),
            this.byteRound((maxRounded * 2) / 3),
            maxRounded,
        ];
        const { Area, AreaChart, CartesianGrid, Label, ReferenceLine, YAxis } = recharts;
        // TODO: animation disabled because https://github.com/recharts/recharts/issues/375
        return (React.createElement("div", { className: "chart-container download-chart", ref: this.setRef },
            React.createElement(ErrorBoundary, null,
                React.createElement(AreaChart, { width: this.state.width, height: 120, data: data },
                    React.createElement(YAxis, { width: 70, tickFormatter: this.valueFormatter, ticks: ticks, domain: [0, maxRounded] }),
                    React.createElement(CartesianGrid, { strokeDasharray: "3 3", vertical: false }),
                    React.createElement(Area, { type: "monotone", dataKey: "speed", isAnimationActive: false, dot: false, fill: "url(#graph-gradient)" }),
                    showLimit ? (React.createElement(ReferenceLine, { y: maxBandwidth, strokeDasharray: "6 2" },
                        React.createElement(Label, { value: t("Bandwidth Limit (see Settings)"), position: "top", onClick: this.openSettings }))) : null)),
            React.createElement(ErrorBoundary, null,
                React.createElement(ResizeDetector, { handleWidth: true, handleHeight: true, onResize: this.onResize }))));
    }
    openSettings = () => {
        const { api } = this.context;
        api.events.emit("show-main-page", "application_settings");
        api.store.dispatch(setSettingsPage("Download"));
        api.highlightControl("#download-bandwidth-limit", 5000, "This limits your download speed.");
    };
    onResize = (width, height) => {
        this.nextState.width = width;
    };
    byteRound(input) {
        const roundVal = 128 * 1024;
        return Math.ceil(input / roundVal) * roundVal;
    }
    setRef = (ref) => {
        if (truthy(ref)) {
            this.onResize(ref.clientWidth, ref.clientHeight);
        }
    };
    valueFormatter = (value) => {
        return bytesToString(value) + "/s";
    };
    /*
    private labelFormatter = (name: string) => {
      return `${speedDataPoints - parseInt(name, 10)}s ago`;
    }*/
    convertData(speeds) {
        const padded = Array(NUM_SPEED_DATA_POINTS - speeds.length)
            .fill(0)
            .concat(speeds);
        return padded.map((value, idx) => ({
            name: idx.toString(),
            speed: value,
            formatted: this.valueFormatter(value),
        }));
    }
}
function mapStateToProps(state) {
    return {
        speeds: state.persistent.downloads.speedHistory,
    };
}
export default connect(mapStateToProps)(DownloadGraph);
